var _effectorFileName = "/src/page-content/payment/components/combobox-services/combobox-services.tsx";
import * as React from 'react';
import { useEffect, useState } from 'react';
import { Service } from '@/pages/api/services/types';
import { CaretSortIcon } from '@radix-ui/react-icons';
import CheckMarkIcon from '@/shared/components/icons/checkmark-icon';
import { Button } from '@/shared/components/ui/button';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/shared/components/ui/command';
import { Popover, PopoverContent, PopoverTrigger } from '@/shared/components/ui/popover';
import { Separator } from '@/shared/components/ui/separator';
import { cn } from '@/shared/lib/cn';
interface ComboboxPaymentProps {
  servicesList: Array<Service>;
  onOptionPick: (serviceCategory: string, variant: any) => void;
}
export const ComboboxServices = (props: ComboboxPaymentProps) => {
  const {
    servicesList,
    onOptionPick
  } = props;
  const onSelect = (serviceCategory: string, variant: any) => {
    setValue({
      lessonType: variant.lessonType,
      lessonPrice: variant.lessonPrice,
      serviceCategory: serviceCategory
    });
    onOptionPick(serviceCategory, variant);
    setOpen(false);
  };
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState({
    lessonPrice: '',
    lessonType: '',
    serviceCategory: ''
  });
  useEffect(() => {
    if (!value.lessonType) return;
    const service = servicesList.find(s => s.category === value.serviceCategory);
    if (!service) return;
    const updatedVariant = service.variants.find(v => v.lessonType === value.lessonType && v.lessonPrice !== value.lessonPrice);
    if (updatedVariant) {
      setValue(prev => ({
        ...prev,
        lessonPrice: updatedVariant.lessonPrice
      }));
      onOptionPick(service.category, updatedVariant);
    }
  }, [servicesList]);
  return <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild className="focus-visible:ring-brand-accent-dark dark:focus-visible:ring-brand-accent-normal">
        <Button variant="outline" size="lg" role="combobox" aria-expanded={open} className="min-w-[50%] justify-between px-4">
          <p className="flex w-full items-center justify-between overflow-hidden text-base sm:text-sm">
            {value.lessonType && <>
                {value.lessonPrice} &#8381; - {value.serviceCategory} - {value.lessonType}
              </>}

            {!value.lessonType && <span className="font-normal text-muted-foreground">Выберите тип урока...</span>}

            <CaretSortIcon className="ml-2 h-4 w-4 shrink-0 opacity-50" />
          </p>
        </Button>
      </PopoverTrigger>

      <PopoverContent className="p-0 xss:min-w-[350px] xs:min-w-[400px] sm:min-w-[300px] md:min-w-[350px] lg:min-w-[500px]" side="bottom" align="center" avoidCollisions={false}>
        <Command>
          <CommandInput placeholder="Введите название..." className="text-base sm:text-sm" />

          <CommandEmpty>Услуг не найдено</CommandEmpty>

          <CommandGroup className="p-4">
            <CommandList>
              {servicesList.map((service, index) => <div key={index}>
                  {index !== 0 && <Separator className="my-2 w-full" />}

                  <p className="font-semibold">{service.category}</p>

                  {service.variants.map((variant, index) => <CommandItem key={index} value={`${variant.lessonType} - ${variant.lessonPrice}`} onSelect={() => onSelect(service.category, variant)} className="mb-2">
                      <CheckMarkIcon className={cn('mr-2 h-4 w-4 shrink-0 rounded-full bg-brand-accent-light p-[2px] text-white dark:bg-brand-accent-normal sm:mr-3 sm:h-5 sm:w-5', value.lessonType === variant.lessonType && value.lessonPrice === variant.lessonPrice ? 'opacity-100' : 'opacity-0')} />

                      <span className="text-sm">
                        {variant.lessonType} - {variant.lessonPrice}
                        &#8381;
                      </span>
                    </CommandItem>)}
                </div>)}
            </CommandList>
          </CommandGroup>
        </Command>
      </PopoverContent>
    </Popover>;
};